import React, { useState } from "react";
import { useParams }from "react-router-dom";
import ReactMarkdown from 'react-markdown';
import OnImagesLoaded from 'react-on-images-loaded';
import BigNumber from 'bignumber.js';
import ContentLoader from "react-content-loader";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OrderSide } from 'opensea-js/lib/types';

function toUnitAmount(baseAmount, tokenContract = null) {
  const decimals = tokenContract && tokenContract.decimals != null
    ? tokenContract.decimals
    : 18

  const amountBN = new BigNumber(baseAmount.toString())
  return amountBN.div(new BigNumber(10).pow(decimals))
}

const Nft = ({seaport}) => {
  const params = useParams();
  const { tokenAddress, tokenId } = params;
  const [asset, setAsset] = useState(null);
  const [order, setOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isBuying, setIsBuying] = useState(false);
  const [accountAddress, setAccountAddress] = useState(null);

  async function buyOrder() {
    try {
      setIsBuying(true);
      await seaport.fulfillOrder({ order: asset.orders[0], accountAddress });
    } catch (e) {
      if(e.message.includes('err: insufficient funds for transfer')) {
        alert('Insufficient funds for transfer.');
      } else if(e.message.includes('MetaMask Tx Signature: User denied transaction signature.')) {
      } else {
        alert('Oops, an error occurred. Please try again later.');
      }
    } finally {
      setIsBuying(false);
    }
  }

  async function connectWallet() {
    if (window.ethereum) {
      await getAccount();
    } else {
      const errorMessage = 'You need an Ethereum wallet to interact with this marketplace. We suggest installing MetaMask.';
      alert(errorMessage);
    }
  }

  async function getAsset() {
    const asset = await seaport.api.getAsset({
      tokenAddress,
      tokenId
    });
    setAsset(asset);

    // const { orders } = await seaport.api.getOrders({
    //   asset_contract_address: tokenAddress,
    //   token_id: tokenId,
    //   side: OrderSide.Sell,
    //   limit: 1
    // });
    // setOrder(orders[0]);
    // setAsset(orders[0].asset);
  }

  async function getAccount() {
    const { ethereum } = window;
    const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
    const account = accounts[0];
    setAccountAddress(account);
  }

  async function getCurrentWalletConnected() {
    if (window.ethereum) {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        if (accounts.length > 0) {
          const account = accounts[0];
          setAccountAddress(account);
        }
      } catch (e) {
        alert(e.message);
      }
    } else {
      const errorMessage = 'You need an Ethereum wallet to interact with this marketplace. We suggest installing MetaMask.';
      alert(errorMessage);
    }
  };

  function addWalletListener() {
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', (accounts) => {
        if (accounts.length > 0) {
          setAccountAddress(accounts[0]);
        } else {
          setAccountAddress(null);
        }
      });
    }
  }
  
  React.useEffect(() => {
    getAsset();
    getCurrentWalletConnected();
    addWalletListener();
  }, []);

  if(!asset) return (
    <ContentLoader 
      speed={2}
      width={300}
      height={300}
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      style={{maxWidth: '100%'}}
    >
      <rect x="0" y="0" rx="2" ry="2" width="150" height="18" />
      <rect x="0" y="30" rx="2" ry="2" width="200" height="18" />
      <rect x="0" y="60" rx="2" ry="2" width="100" height="18" />
      <rect x="0" y="90" rx="2" ry="2" width="250" height="18" /> 
    </ContentLoader>
  );

  // const isETH = order.paymentTokenContract.symbol === "ETH";
  // const price = parseFloat(toUnitAmount(order.currentPrice, order.paymentTokenContract)).toLocaleString(undefined, { minimumSignificantDigits: 1 });
  
  return (
    <>
      <OnImagesLoaded
        onLoaded={() => setIsLoading(false)}
      >
        <div className="nft-image" style={{display: isLoading ? 'none' : 'block'}}><img src={asset.imageUrl.replace('=s250', '=s600')} alt="" /></div>
        <div className="nft-image" style={{display: !isLoading ? 'none' : 'block'}}><img src={asset.imagePreviewUrl} alt="" /></div>
      </OnImagesLoaded>
      <div className="nft-blurb">
        <div className="nft-order">
          <img src={asset.owner.profile_img_url} alt={asset.owner.user?.username || asset.owner.address} width="40" height="40" />
          <div className="nft-owner">
            <h4>{asset.owner.address !== '0x0000000000000000000000000000000000000000' ? (asset.owner.user?.username || asset.owner.address) : asset.collection.name}</h4>
            <h5>{asset.owner.address !== '0x0000000000000000000000000000000000000000' ? asset.owner.address : asset.tokenAddress}</h5>
          </div>
          {/* <div className="nft-price">{isETH ? 'Ξ' : null}{price} {isETH ? null : asset.collection.paymentTokens[0].symbol}</div> */}
          {!accountAddress && <Button onClick={connectWallet} color="primary" style={{width:'100%',marginTop:'10px'}}>Connect Wallet</Button>}
          {accountAddress && <Button className="btn-buy" disabled={isBuying} onClick={buyOrder} color="primary" style={{width:'100%',marginTop:'10px'}}>{isBuying && <FontAwesomeIcon icon="spinner" className="fa-spin" />}Buy Now</Button>}
        </div>
        <h1>{asset.name || tokenId}</h1>
        <div className="nft-collection"><Link to={`/nft/${asset.collection.slug}`}>{asset.collection.name}</Link></div>
        <div className="nft-description">
          <ReactMarkdown>{asset.description}</ReactMarkdown>
          <ReactMarkdown>{asset.collection.description ? asset.collection.description.replace(/ \r/, '').replace(/\r/, '').replace(asset.description, '') : ''}</ReactMarkdown>
        </div>
      </div>
    </>
  );
};

export default Nft;